import { GraphUtils } from './../../../../../lib/graph/graph-utils';
import {
  BdGraph,
  BdGraphFactory
} from './../../../../../lib/graph/graph.model';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { uniq } from 'lodash';

/**
 *
 * Copy the node from the view graph over to the search results graph
 * Handles the node's ancestors recursively.
 *
 * @param searchGraph Search results in graph form
 * @param node The search result
 * @param viewGraph The original view graph
 */
function copyNodeToSearchGraph(
  searchGraph: BdGraph<ViewTreeNode>,
  node: ViewTreeNode,
  viewGraph: BdGraph<ViewTreeNode>
) {
  // add node
  GraphUtils.addNode(searchGraph, node);
  const parent = GraphUtils.getAncestor(viewGraph, node.id);

  if (parent) {
    // add successor
    const successors = searchGraph.successors[parent] || [];
    successors.push(node.id);
    searchGraph.successors[parent] = uniq(successors);

    // add predecessor
    searchGraph.predecessors[node.id] = parent;

    // recurse with the parent
    return copyNodeToSearchGraph(
      searchGraph,
      GraphUtils.getNode(viewGraph, parent),
      viewGraph
    );
  }

  // if there's no parent, this node must be a root
  GraphUtils.addRootNode(searchGraph, node);
  return searchGraph;
}

export function getSearchTree(
  viewGraph: BdGraph<ViewTreeNode>,
  searchResults: ViewTreeNode[]
): BdGraph<ViewTreeNode> {
  const searchTree = BdGraphFactory<ViewTreeNode>();
  return searchResults.reduce(
    (acc, result) => copyNodeToSearchGraph(acc, result, viewGraph),
    searchTree
  );
}
